import { SDUIHeaderRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Header/SDUIHeaderRenderer";
import { NLSSuggestionsSection } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/SearchDropdown/NLSSuggestionsSection";
import { SDUISimpleActionBannerRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/SearchDropdown/SDUISimpleActionBannerRenderer";
import { SDUISearchSuggestionsRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/SearchDropdown/SearchSuggestions/SDUISearchSuggestionsRenderer";
import { SDUIRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/SDUIRenderer/SDUIRenderer";
import { SDUILayoutSectionRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/SectionRenderers/LayoutSection/SDUILayoutSectionRenderer";
import {
  ComponentRenderMap,
  SectionRenderMap,
} from "@faire/deprecated-retailer-visitor-shared/components/SDUI/types";
import { getRetailer } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getRetailer";
import { useSettingEnableNLSSearch } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingEnableNLSSearch";
import { useQuery as useSearchSuggestionsEmptyStateQuery } from "@faire/web-api--source/endpoints/www/api/v3/layout/search/empty-page-suggestions/retailerToken/get-hooks";
import { Spacer } from "@faire/web/slate/spacing/spacing";

const componentRenderers: ComponentRenderMap = {
  search_suggestions_component: {
    active: SDUISearchSuggestionsRenderer,
  },
  simple_action_banner_component: {
    active: SDUISimpleActionBannerRenderer,
  },
  header_component: {
    active: SDUIHeaderRenderer,
  },
};
const sectionRenderers: SectionRenderMap = {
  layout_section: SDUILayoutSectionRenderer,
};

export const SDUISearchDropdownEmptyState = ({
  submit,
}: {
  submit: (query: string, submittedUrl?: string, navigate?: boolean) => void;
}) => {
  const retailerToken = getRetailer()?.token ?? "";
  const { data } = useSearchSuggestionsEmptyStateQuery(retailerToken);
  const shouldShowNLSSearchSuggestions = useSettingEnableNLSSearch();

  if (!data?.view_layout) {
    return null;
  }

  const { view_layout } = data;

  const hasNLSSuggestions =
    data?.suggested_natural_language_search_queries &&
    data?.suggested_natural_language_search_queries.length > 0;

  return (
    <div data-test-id="SDUI-search-dropdown-empty-state">
      {shouldShowNLSSearchSuggestions && hasNLSSuggestions ? (
        <NLSSuggestionsSection
          suggestions={data?.suggested_natural_language_search_queries}
          submit={submit}
        />
      ) : null}
      <SDUIRenderer
        componentRenderers={componentRenderers}
        sectionRenderers={sectionRenderers}
        viewLayout={view_layout}
      />
      <Spacer size="1x" />
    </div>
  );
};
